import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { SideNavComponent } from "@app/shared-core/components/side-nav/components/side-nav/side-nav.component";
import { TopNavComponent } from "@app/shared-core/components/top-nav/top-nav.component";
import { ActionsNavComponent } from "@app/shared-core/components/actions-nav/components/actions-nav/actions-nav.component";
import { PopupWrapperComponent } from "@app/kernel/popups/popups.config";

@Component({
  selector: "app-main-layout",
  imports: [RouterOutlet, SideNavComponent, TopNavComponent, ActionsNavComponent, PopupWrapperComponent],
  templateUrl: "./main-layout.component.html",
  styleUrl: "./main-layout.component.scss",
})
export class MainLayoutComponent {}
